"use client";

import { useEffect, useState } from "react";

/**
 * The y position just below the site header (plus a gap), following the
 * header's bottom edge as it shrinks on scroll. Null until measured, so a
 * floating element can stay hidden for its first paint.
 */
export function useBelowHeader(gap = 12): number | null {
  const [top, setTop] = useState<number | null>(null);
  useEffect(() => {
    const header = document.querySelector("header");
    if (!header) return;
    const update = () => setTop(Math.max(header.getBoundingClientRect().bottom, 0) + gap);
    const frame = window.requestAnimationFrame(update);
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    const observer = new ResizeObserver(update);
    observer.observe(header);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      observer.disconnect();
    };
  }, [gap]);
  return top;
}
